module.exports = __webpack_public_path__ + "7511c3d440262e8583381418aa18570e.fbx";